import { Container, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  appSetup,
  getAllCategories,
  SocialLink,
} from "../../features/master/masterSlice";
import { useEffect } from "react";
import { getGroupByProduct } from "../../features/products/productsSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollAnimation from "react-animate-on-scroll";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    // first navigate to Categories page
    dispatch(getGroupByProduct({ p_category_id: id }));
    // Wait a bit to let the Categories component mount
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // tweak delay if needed
    navigate(`/categories?category_id=${id}`, { state: { scrollToId: id } });
    // navigate(`/categories?category_id=${id}`);
  };

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const sociallink = useSelector((state) => state.master.social_link);

  useEffect(() => {
    dispatch(SocialLink());
  }, [dispatch]);

  const isSignin = useSelector((state) => state.auth.is_signin);

  const app_setup = useSelector((state) => state.master.app_setup);

  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);

  return (
    <footer className="Footer">
      {/* <ScrollAnimation 
      // animateIn={"fadeInRight"}
      > */}


      <div className="container">
        <Row>
          <Col lg={4} sm={12} xs={12} className="footer-brand order-md-1 order-1">
            <Link to="/" className="">
              <div className="logo_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                  className="logo_img"
                />
              </div>
            </Link>

            <div className="social-icons">
              {sociallink?.map((val) => (
                <a
                  href={val?.url}
                  className="social-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  key={val?.id || val?.url}
                >
                  <img
                    src={process.env.REACT_APP_IMG_URL + val?.image}
                    className="social_icon_img"
                    alt="Social icon"
                  />
                </a>
              ))}

              {/* {sociallink?.map((val) => (
                <Link to={val?.url} className="social-icon">
                  <img
                    src={process.env.REACT_APP_IMG_URL + val?.image}
                    className="social_icon_img"
                    alt="Get it on Google Play"
                  />
                
                </Link>
              ))} */}
              {/* <Link to="#" className="social-icon">
                <FontAwesomeIcon icon={faGoogle} />
              </Link>
              <Link to="#" className="social-icon">
                <FontAwesomeIcon icon={faTwitter} />
              </Link>
              <Link to="#" className="social-icon">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </Link> */}
            </div>
          </Col>

          {/* <Col
            lg={3}
            sm={4}
            xs={6}
            className="footer-links order-md-2 order-3"
          >
            <h3>Categories</h3>
            <ul>
              {category?.map((val) => (
                <li>
                  <a onClick={() => scrollToSection(val?.id)}>
                    <p>{val?.name}</p>
                  </a>
                </li>
              ))}

            </ul>
          </Col> */}


          <Col lg={4} sm={6} xs={6} className="footer-links order-md-3 order-4">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">
                  <p>Home</p>
                </Link>
              </li>
              <li>
                <Link to="/about-us">
                  <p>About Us</p>
                </Link>
              </li>
              <li>
                <Link to="/categories">
                  <p>Category</p>
                </Link>
              </li>

              {/* <li>
                <Link to="/shops">
                  <p>Shops</p>
                </Link>
              </li> */}

              {/* <li>
                <Link to="/blog">
                  <p>Blog</p>
                </Link>
              </li> */}

              <li>
                <Link to="/contact">
                  <p>Contact Us</p>
                </Link>
              </li>
              <li>
                <Link to="/wallet">
                  <p>Wallet</p>
                </Link>
              </li>
              <li>
                <Link to="/terms">
                  <p>Terms & Conditions</p>
                </Link>
              </li>
              <li>
                <Link to="/privacy">
                  <p>Privacy Policy</p>
                </Link>
              </li>
              {isSignin && (
                <li>
                  <Link to="/account">
                    <p>Your Account</p>
                  </Link>
                </li>
              )}

              <li>
                <Link to="/wishlist">
                  <p>Your Wishlist</p>
                </Link>
              </li>
              <li>
                <Link to="/faqs">
                  <p>FAQs</p>
                </Link>
              </li>
            </ul>
          </Col>

          <Col lg={4} sm={6} xs={12} className="footer-links order-md-4 order-5">
            <h3>Get in Touch</h3>

            <div className="contact-section">
              <h4>Customer Support</h4>
              <Link to={`mailto:${app_setup?.email}`} target="_blank">
                <p>Email: {app_setup?.email}</p>
              </Link>
              <Link to={`tel:${app_setup?.contact_no}`} target="_blank">
                <p>Phone: {app_setup?.contact_no}</p>
              </Link>
            </div>



            <div className="contact-section">
              <h4>Phone for Corporate Queries</h4>
              <Link to={`tel:${app_setup?.alt_contact_no}`} target="_blank">
                <p>Phone: {app_setup?.alt_contact_no}</p>
              </Link>
            </div>


{/* 
            <div className="contact-section">
              <h4>Address</h4>
              <p>
                <b>Soubhagya Treaders</b>
              </p>
              <p>{app_setup?.address}</p>
            </div> */}

          </Col>

        </Row>
      </div>

      <Row className="me-0 ms-0">
        <Col className="copyright">
          <p>©2026 Soubhagya Treaders. All Rights Reserved | Developed by <Link to={"https://profcymaglobal.com/"} target="_blank">
            Profcyma Solutions Pvt Ltd
          </Link>
          </p>
        </Col>
      </Row>

      {/* </ScrollAnimation> */}
    </footer>
  );
};

export default Footer;
